export default "__VITE_ASSET__C98lTU89__"